import { arrayOf, string } from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { userShape } from '../../prop-types';
import { listColumns } from '../user-columns';

function List({ data, team }) {
  return (
    <ReactTable
      columns={listColumns}
      data={data}
      minRows={2}
      defaultFiltered={[{ id: 'team', value: team }]}
    />
  );
}

List.propTypes = {
  data: arrayOf(userShape).isRequired,
  team: string,
};

List.defaultProps = {
  team: '',
};

export default List;
